import { FC } from "react";
import ChevronLeft from "@/assets/images/ChevronLeft";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import classNames from "classnames";

interface GoBackButtonProps {
  onClick: () => void;
  className?: string;
}

const GoBackButton: FC<GoBackButtonProps> = ({ onClick, className }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.container, className)} onClick={onClick}>
      <ChevronLeft />
      <span className={styles.text}>{t("ui.back")}</span>
    </div>
  );
};

export default GoBackButton;
